import type { Theme } from '@/@types/theme';
import { themePixbetColors } from '@/themes/brandColors/pixbet';

export const ThemePixbet: Theme = {
  name: 'pixbet',
  dark: true,
  colors: themePixbetColors,
};
